import type { IFilterableListItem, IOmit, ISuggestProps } from '@sixui/ui';
import { forwardRef } from 'react';
import { Field, Skeleton, Suggest } from '@sixui/ui';

import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { useArticlesQuery } from '~/lib/api/modules/Articles/hooks/useArticlesQuery';

export type IArticleSelectorProps = IOmit<ISuggestProps, 'items'> & {
  appId: string;
  categoryId?: string;
};

export const ArticleSelector = forwardRef<
  HTMLInputElement,
  IArticleSelectorProps
>(function ArticleSelector(props, forwardedRef) {
  const { appId, categoryId, ...other } = props;
  const canQuery = !!categoryId;

  const articlesQuery = useArticlesQuery(
    {
      appId,
      body: {
        category: categoryId,
        limit: 999,
      },
    },
    { enabled: canQuery },
  );
  const loading = articlesQuery.isLoading || articlesQuery.isIdle;
  const items: Array<IFilterableListItem> =
    articlesQuery.data?.articles?.map(({ _id, title }) => ({
      value: _id,
      label: title,
    })) ?? [];

  return articlesQuery.isError ? (
    <ErrorMessage error={articlesQuery.error} />
  ) : !canQuery || !!articlesQuery.data || !loading ? (
    <Suggest {...other} items={items} ref={forwardedRef} />
  ) : (
    <Skeleton>
      <Field />
    </Skeleton>
  );
});
